import { render, staticRenderFns } from "./ClientSortedList.vue?vue&type=template&id=71f40654&scoped=true&"
import script from "./ClientSortedList.vue?vue&type=script&lang=js&"
export * from "./ClientSortedList.vue?vue&type=script&lang=js&"
import style0 from "./ClientSortedList.vue?vue&type=style&index=0&id=71f40654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f40654",
  null
  
)

export default component.exports